import ContactForm from '../contact-form';

const ContactFormModal = ({ onClose }) => {
  return (
    <div className="contact-form__modal-body">
      <button
        type="button"
        className="contact-form__modal-body__btn-close"
        onClick={onClose}
        title="Close"
      />
      <div className="contact-form__modal-body__wrapper">
        <ContactForm onClose={onClose} />
      </div>
    </div>
  );
};

export default ContactFormModal;
